export default __webpack_public_path__ + "static/media/runPunStrava.897f159b.png";